export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const PDFSERVER_URL = process.env.REACT_APP_PDFSERVER_URL;
export const DEMO = process.env.REACT_APP_DEMO === 'true'
export const DEBUG = window.location.hash.includes("debug")
export const LAYOUT_DATA_URL = process.env.REACT_APP_LAYOUT_DATA_URL
export const LAYOUT_DATA_AUTH = process.env.REACT_APP_LAYOUT_DATA_AUTH

export const NIA_LOGIN_URL = process.env.REACT_APP_NIA_LOGIN_URL
export const NIA_STATE_URL = process.env.REACT_APP_NIA_STATE_URL
export const ARES_URL = process.env.REACT_APP_ARES_URL
export const SUKL_USERS_URL = process.env.REACT_APP_SUKL_USERS_URL

export const SUKL_API = process.env.REACT_APP_SUKL_URL
export const DIST_URL = process.env.REACT_APP_DIST_URL
export const SUKL_CODE_LENGTH = 7

export const DISEASE_ENUMERATION_GROUP_ID =
  '03433dfe-3f3a-4ff6-b65e-dfe9243c463d'
